<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_91_451)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.15794 7.11508C5.30759 7.11508 4.61824 7.80443 4.61824 8.65479V9.17549H7.69764V8.65479C7.69764 7.80443 7.00829 7.11508 6.15794 7.11508ZM2.73824 8.65479C2.73824 6.86524 4.11283 5.39675 5.86375 5.24756V5.23508H6.15794H16.3621C18.1099 5.23508 19.7818 6.4773 19.7818 8.30113V14.9445H21.3218H22.2618V15.8845V17.3452C22.2618 19.2339 20.7307 20.7649 18.8421 20.7649L11.1057 20.7649L11.1029 20.7649H11.1027L10.5489 20.7649V20.7203C9.07799 20.4806 7.92224 19.3027 7.71604 17.8208H7.69764V17.6612C7.68811 17.5572 7.68323 17.4518 7.68323 17.3452L7.68323 13.9218H7.69764V11.0555H3.67824H2.73824V10.1155V8.65479ZM9.57764 17.5567C9.68071 18.307 10.3243 18.8849 11.1029 18.8849H11.1039C11.9537 18.8843 12.6424 18.1952 12.6424 17.3452V15.8845V14.9445H13.5824H16.757H17.9018V8.30113C17.9018 7.77659 17.3534 7.11508 16.3621 7.11508H9.21224C9.44597 7.57784 9.57764 8.10094 9.57764 8.65479V17.5567ZM18.8421 18.8849L14.157 18.8849C14.3907 18.4222 14.5224 17.8991 14.5224 17.3452V16.8245H16.757H18.1042H20.3818V17.3452C20.3818 18.1956 19.6924 18.8849 18.8421 18.8849ZM16.3493 10.319H11.3891V8.91898H16.3493V10.319ZM11.3891 12.9974H16.3493V11.5974H11.3891V12.9974Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_91_451">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
